import mifosRepository, { MifosRepository } from "./MifosRepository";

const resource = "/address";
const APPLICATION_JSON = "application/json";

export default {
  getAddressByAddressId(addressId) {
    mifosRepository.setContentType(APPLICATION_JSON);
    return MifosRepository.get(`${resource}/${addressId}`);
  }
}
